import React from 'react';
import PropTypes from 'prop-types';

/**
 * MaintenanceBanner Component
 * 
 * Displays a maintenance notice banner at the top of the page.
 * Reuses the existing .top-banner CSS styling.
 * 
 * @param {Array<string|React.ReactNode>} paragraphs - Array of content for each paragraph
 */
const MaintenanceBanner = ({ paragraphs }) => {
    if (!paragraphs || paragraphs.length === 0) {
        return null;
    }

    return (
        <div className="top-banner">
            <div className="top-banner-content">
                {paragraphs.map((content, index) => (
                    <p key={index} className="top-banner-paragraph">
                        {content}
                    </p>
                ))}
            </div>
        </div>
    );
};

MaintenanceBanner.propTypes = {
    paragraphs: PropTypes.arrayOf(PropTypes.node),
};

export default MaintenanceBanner;

